import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsDiscordComponent } from './simple-icons-discord.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsDiscordComponent ],
    exports:      [ SimpleIconsDiscordComponent ],
    bootstrap:    []
})
export class SimpleIconsDiscordModule {}
